import React, {useState, useEffect, useCallback, useMemo} from 'react'
import {useIntl} from 'react-intl'
import {KTCard, KTCardBody, Table, Loading} from '../../../components'
import {CustomCell} from '../../../components/Table/columns/CustomCell'
import {CustomHeader} from '../../../components/Table/columns/CustomHeader'
import {ListHeader} from '../../../components/Table/header/ListHeader'
import {ListLoading} from '../../../components/Table/ListLoading'
import {PageTitle} from '../../../core'

import {useDispatch, useSelector} from 'react-redux'
import {
  purchaseProposalRequestGetAllSearch,
  purchaseProposalRequestExcel,
} from '../../../redux/slices/purchase.slice'

import {
  useMemoizedStaticData
} from '../../../utils/performanceOptimizations'

const selectPurchaseData = (state) => ({
  requestProposal: state.purchase.requestProposal,
  loading: state.purchase.loading
})

function List() {
  const intl = useIntl()
  const {requestProposal, loading} = useSelector(selectPurchaseData)
  const dispatch = useDispatch()

  const [params, setParams] = useState()

  useEffect(() => {
    if (params) dispatch(purchaseProposalRequestGetAllSearch(params))
  }, [dispatch, params])

  const handleSorting = useCallback((item) => {
    setParams((prevState) => ({...prevState, sort: item && item.sort, order: item && item.order}))
  }, [])

  const handleSearch = useCallback((item) => {
    setParams((prevState) => ({...prevState, name: item}))
  }, [])

  const handlePagination = useCallback((pagination) => {
    setParams((prevState) => ({...prevState, ...pagination}))
  }, [])

  const handleFilterSubmit = useCallback((values) => {
    setParams({...values})
  }, [])

  const handleExcelExport = useCallback(() => {
    dispatch(
      purchaseProposalRequestExcel({
        params,
        fileName: intl.formatMessage({id: 'BC.PURCHASEPROPOSALREQUEST'}),
      })
    )
  }, [dispatch, params, intl])

  const columns = useMemo(() => [
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          handleChangeSorting={handleSorting}
          title={intl.formatMessage({
            id: 'PURCHASEPROPOSALREQUEST.SEARCH.PURCHASEPROPOSALREQUESTNAME',
          })}
          className='min-w-125px'
        />
      ),
      accessor: 'purchaseRequestName',
      Cell: ({...props}) => (
        <CustomCell
          item={props}
          to={`/purchase/request/detail/${props.data[props.row.index].purchaseRequestId}`}
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          handleChangeSorting={handleSorting}
          title={intl.formatMessage({
            id: 'PURCHASEPROPOSALREQUEST.SEARCH.PURCHASEPROPOSALCOMPANYNAME',
          })}
          className='min-w-125px'
        />
      ),
      accessor: 'proposalCompanyName',
      Cell: ({...props}) => (
        <CustomCell
          item={props}
          to={`/purchase/request/detail/${props.data[props.row.index].purchaseRequestId}`}
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          handleChangeSorting={handleSorting}
          title={intl.formatMessage({id: 'PURCHASEPROPOSALREQUEST.SEARCH.LATESTDATEPROPOSAL'})}
          className='min-w-125px'
        />
      ),
      accessor: 'latestDateProposal',
      Cell: ({...props}) => (
        <CustomCell
          item={props}
          date='short'
          to={`/purchase/request/detail/${props.data[props.row.index].purchaseRequestId}`}
        />
      ),
    },
  ], [intl, handleSorting])

  const buttons = useMemo(() => [], [])

  const actionButtons = useMemoizedStaticData(() => [
    {
      title: 'BUTTON.EXCEL',
      onClick: handleExcelExport,
      icon: '/images/icons/duotune/arrows/arr044.svg',
      variant: 'light-primary',
    },
    {
      title: 'FILTER',
      icon: '/images/icons/duotune/general/gen031.svg',
      variant: 'light-primary',
      list: [
        {
          title: 'PURCHASEPROPOSALREQUEST.SEARCH.PURCHASEPROPOSALREQUESTNAME',
          name: 'purchaseRequestName',
          type: 'text',
        },
        {
          title: 'PURCHASEPROPOSALREQUEST.SEARCH.PURCHASEPROPOSALCOMPANYNAME',
          name: 'proposalCompanyName',
          type: 'text',
        },
      ],
    },
  ], [handleExcelExport])

  return (
    <>
      <PageTitle>{intl.formatMessage({id: 'BC.PURCHASEPROPOSALREQUEST'})}</PageTitle>
      <KTCard>
        <ListHeader
          search={handleSearch}
          actionButtons={actionButtons}
          onSubmit={handleFilterSubmit}
          pages={'PURCHASEPROPOSALREQUEST'}
          buttons={buttons}
        />
        <KTCardBody>
          {!requestProposal && <ListLoading />}
          {requestProposal && (
            <Table
              items={requestProposal}
              cols={columns}
              handlePagination={handlePagination}
              paddless
            />
          )}
        </KTCardBody>
      </KTCard>

      {loading && <Loading />}
    </>
  )
}
export {List}
